// 全部保单接口
import request from '../request'
import qs from 'qs'
// 七，银行卡信息
// 获取银行卡列表
const bankCardInfo = (data) => {
  return request.post(
    `/api/wx/auth/bankInfo/bankCardInfo?${qs.stringify(data)}`
  )
}
const queryBranchBankList = (data) => {
  return request.post('/api/wx/auth/bankInfo/getBrachOfBankInfoList', data)
}
const uploadBankCardImg = (data) => {
  return request.post(`/api/wx/auth/uploadBankCardImg`, data)
}
// 绑定银行卡
const bindBankInfo = (data) => {
  return request.post('/api/wx/auth/bankInfo/bindBankInfo', data)
}
// 删除银行卡
const deleteBankCardInfo = (data) => {
  return request.post(
    `/api/wx/auth/bankInfo/deleteBankCardInfo?${qs.stringify(data)}`
  )
}
// 变更主领卡号信息
const changebankCardInfo = (data) => {
  return request.post(
    '/api/wx/auth/bankInfo/changebankCardInfo',
    qs.stringify(data)
  )
}
// 获取总行信息
const getBankInfoList = (data) => {
  return request.post(
    '/api/wx/auth/bankInfo/getBankInfoList',
    qs.stringify(data)
  )
}
// 获取支行信息
const getBrachOfBankInfoList = (data) => {
  return request.post(
    '/api/wx/auth/bankInfo/getBrachOfBankInfoList',
    qs.stringify(data)
  )
}
// 解绑银行卡信息
const unbindbankCardInfo = (data) => {
  return request.post(
    '/api/wx/auth/bankInfo/unbindbankCardInfo',
    qs.stringify(data)
  )
}
// 获取被保人列表
const getMemberInfo = (data) => {
  return request.post(
    '/api/wx/auth/memberInfo/getMemberInfo',
    qs.stringify(data)
  )
}
// 查询国家
const getCountryList = function (data) {
  return request.post(
    `/api/wx/auth/bankInfo/getCountryList?${qs.stringify(data)}`
  )
}
// 对象数组
export default {
  bankCardInfo,
  queryBranchBankList,
  uploadBankCardImg,
  bindBankInfo,
  deleteBankCardInfo,
  changebankCardInfo,
  getBankInfoList,
  getBrachOfBankInfoList,
  unbindbankCardInfo,
  getMemberInfo,
  getCountryList
}
